<template>
  <div >
    <b-card class="formContact mt-3 p-md-4 mb-3" header="">
      <b-form @submit.stop.prevent>
        <!--FULL NAME -->
        <label for="full_name" class="label">{{fullName[$props.lang]}}</label>
        <b-form-input class="input" type="text" id="full_name" v-model="name"
                      aria-describedby="name-help-block" :placeholder="fullName_Note[$props.lang]"></b-form-input>
        <b-form-text id="name-help-block" class="help">
          {{fullName_Note[$props.lang]}}
        </b-form-text>
        <!--PHONE NUMBER -->
        <label for="phone" class="label">{{phoneNumber[$props.lang]}}</label>
        <PhoneInput v-model="phone" :lang="$props.lang" country="CO" />
        <!--<b-form-input class="input" type="phone" id="phone" v-model="phone"
                      aria-describedby="name-help-block" :placeholder="phoneNumber_Note[$props.lang]"></b-form-input>-->
        <b-form-text id="name-help-block" class="help">
          {{phoneNumber_Note[$props.lang]}}
        </b-form-text>
        <!--PHONE EMAIL -->
        <label for="email" class="label">{{lemail[$props.lang]}}</label>
        <b-form-input class="input" type="email" id="email" v-model="email"
                      aria-describedby="name-help-block" :placeholder="lemail_Note[$props.lang]"></b-form-input>
        <b-form-text id="name-help-block" class="help">
          {{lemail_Note[$props.lang]}}
        </b-form-text>
        <!-- NEED -->
        <label for="txtmsg" class="label">{{detailYNeed[$props.lang]}}</label>
        <b-form-textarea
          id="txtmsg"
          v-model="message"
          class="input"
          :placeholder="detailYNeed_Note[$props.lang]"
          rows="5"
          max-rows="6"
        ></b-form-textarea>
        <b-form-text id="name-help-block" class="help">
          {{detailYNeed_Note[$props.lang]}}
        </b-form-text>
        <div class="text-center pt-2">
          <ButtonComponent class="m-0" variant="secondary" :text="send.text[$props.lang]"  @click="sendmsg()" icon="arrow-right-circle-fill" icon-position="end" />
        </div>
        <div class="text-center pt-2">
          <small class="text-muted" style="font-size:12px;">{{privacyPolicy[$props.lang]}}</small>
        </div>
       </b-form>
    </b-card>
    <b-modal id="modal-contact" :title="modalTitle[$props.lang]">
      <p class="my-4">{{successMessage[$props.lang]}}</p>
      <template v-slot:modal-footer="{ ok }">
        <ButtonComponent class="m-0" variant="secondary" text="Cerrar" @click="ok()" icon="x-circle-fill" icon-position="end" />
      </template>
    </b-modal>
  </div>
</template>

<script>
import ButtonComponent from "../buttons/ButtonComponent.vue";
import axios from 'axios'
import PhoneInput from '../input/PhoneInput.vue';
export default {
  name: 'FormContactComponent',
  components: {
    PhoneInput,
    ButtonComponent
  },
  props: {
    lang: String
  },
  beforeMount(){
    if(this.lang === undefined){
      this.lang='es'
    }
  },
  data: function () {
    return {
      modalTitle: {
        ES: "Gracias por contactarnos.",
        EN: "Thank you for contacting us."
      },
      successMessage: {
        ES: "Hemos remitido tu solicitud, muy pronto nuestro equipo te contactara.",
        EN: "We have sent your request, our team will contact you soon."
      },
      fullName:{
        ES: "Nombre Completo",
        EN:"Full name"
      },
      fullName_Note: {
        ES: "Escribe tu nombre completo para ponernos en contacto.",
        EN: "Type your name to contact you."
      },
      phoneNumber:{
        ES: "Número de teléfono",
        EN:"Phone Number"
      },
      phoneNumber_Note: {
        ES: "Escribe tu número de teléfono.",
        EN: "Type your phone number."
      },
      lemail:{
        ES: "Email",
        EN:"Email"
      },
      lemail_Note: {
        ES: "Escribe tu email de contacto.",
        EN: "Type your contact email."
      },
      detailYNeed:{
        ES: "Detalle de la Necesidad.",
        EN: "Detail your Need."
      },
      detailYNeed_Note:{
        ES: "Describe claramente tu necesidad, se concreto, si deseas puedes mencionar aspectos técnicos ó lo que consideres relevante.",
        EN: "Clearly describe your need, be specific, if you wish you can mention technical aspects or anything you consider relevant."
      },
      privacyPolicy:{
        ES: 'Al enviar este mensaje aceptas nuestros términos de uso y políticas de privacidad.',
        EN: 'By sending this message you accept our terms of use and privacy policies.'
      },
      send: {
        text: { ES: "Enviar Solicitud", EN: "Send request" },
        class: "button--secundary",
        link: "",
      },
      name: '',
      phone: '',
      email: '',
      message: ''
    }
  },
  methods:{
    sendmsg: function(){
      let formData = new FormData();
      formData.append("nombre_cliente", this.name);
      formData.append("email_cliente", this.email);
      formData.append("telefono_cliente", this.phone);
      formData.append("descripcion", 'Mensaje enviado desde web site Systemico: '+this.message);
      formData.append('api_client', clienteid);

      //this.$store.commit('setLoading', true);

      axios.post('https://suppmail.systemico.net/customer/cliente_ticket_crear',formData).then(response => {
        let res = response.data
        if (res.CODIGO == 1) {
          this.$bvModal.show('modal-contact')
          this.name = ''
          this.phone = ''
          this.email = ''
          this.message = ''
          //this.$store.commit('setNotification', { state: true, title: 'Éxito', text: 'Recomendación enviada correctamente' });
          //this.close();
        }
        else if(res.CODIGO != 6) {
          //this.$store.commit('setNotification', { state: true, title: 'Error', text: response.MENSAJE });
        }
      });

      //this.$store.commit('setLoading', false);

    }
  }
}
</script>

<style lang="scss" scoped>
  .formContact{
    background:#f8f8f8 !important;
    border-radius:1em;
  }
  .label{
    font-size:16px;
    font-weight:bold;
    color:#444444;
  }
  .input{
    font-size:16px;
    font-family:"Roboto", sans-serif;
    margin-bottom:1em;
  }
  .help{
    font-size:11px;
    display: none;
  }
</style>
